export * as Api from './api';

export interface TaxYear {
  start: number;
  end: number;
}

export enum TaxYearStatus {
  NotApproved = 'NOT_APPROVED',
  Approved = 'APPROVED',
}
